import {
  AUDIT_READ,
  BULK_SERVICES_READ,
  EMAIL_SUPPORT_READ,
  FRAUD_SUPPORT_READ,
  JOBRUNR_READ,
  LICENSES_DELETE,
  LICENSES_READ,
  LICENSES_UPDATE,
  PORT_ORDERS_READ,
  SEND_EMAILS_READ,
  SUPPORT_TOOLS_READ,
  VCC_READ,
  GLOBAL_DIALPLANS_WRITE,
} from "@/react/services/rbac/permissions";
import {
  TAP_TOOLS_CANCELATION,
  TAP_TOOLS_DIAL_PLAN_ADMIN,
  TAP_TOOLS_FRAUD_SUPPORT,
  TAP_TOOLS_PS,
  TAP_TOOLS_SUPER,
  TAP_TOOLS_SUPPORT,
  TAP_TOOLS_THOR,
  TAP_TOOLS_TIER_1,
} from "@/react/services/rbac/groups";

const PROFESSIONAL_SERVICES_AND_SUPPORT = [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT];

const permissionToRole = Object.freeze({
  [VCC_READ]: PROFESSIONAL_SERVICES_AND_SUPPORT,
  [BULK_SERVICES_READ]: PROFESSIONAL_SERVICES_AND_SUPPORT,
  [SEND_EMAILS_READ]: [TAP_TOOLS_THOR],
  [PORT_ORDERS_READ]: [TAP_TOOLS_PS],
  [SUPPORT_TOOLS_READ]: [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT, TAP_TOOLS_THOR],
  [AUDIT_READ]: [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT, TAP_TOOLS_TIER_1],
  [EMAIL_SUPPORT_READ]: [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT, TAP_TOOLS_TIER_1],
  [FRAUD_SUPPORT_READ]: [TAP_TOOLS_FRAUD_SUPPORT],
  [LICENSES_READ]: [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT, TAP_TOOLS_CANCELATION],
  [LICENSES_UPDATE]: [TAP_TOOLS_PS, TAP_TOOLS_SUPPORT, TAP_TOOLS_CANCELATION],
  [LICENSES_DELETE]: [TAP_TOOLS_CANCELATION],
  [JOBRUNR_READ]: [TAP_TOOLS_SUPER],
  [GLOBAL_DIALPLANS_WRITE]: [TAP_TOOLS_DIAL_PLAN_ADMIN, TAP_TOOLS_SUPER],
});

export const getRoles = (permission) => permissionToRole[permission] || [];
